export const SET_HOME_OFFERS = 'SET_HOME_OFFERS'
export const SET_ALL_OFFERS = 'SET_ALL_OFFERS'
export const SET_OFFER_DETAILS = 'SET_OFFER_DETAILS'
export const SET_CROSS_SELLING_OFFERS = 'SET_CROSS_SELLING_OFFERS'
export const FAILED_SET_OFFERS = 'FAILED_SET_OFFERS'
export const SET_SWITCH_OFFER = 'SET_SWITCH_OFFER'
